import { useCallback, useEffect, useState } from 'react';
import { fetchMyProfileVisits } from '../api/profileVisitsApi';

export function useProfileVisits(options = {}) {
  const enabled = options.enabled !== false;
  const limit = Number(options.limit || 6);

  const [visits, setVisits] = useState([]);
  const [loading, setLoading] = useState(Boolean(enabled));
  const [error, setError] = useState(null);
  const [enabledState, setEnabledState] = useState(true);

  const reload = useCallback(async () => {
    if (!enabled) {
      setVisits([]);
      setLoading(false);
      setError(null);
      return null;
    }

    setLoading(true);
    setError(null);

    try {
      const data = await fetchMyProfileVisits(limit);
      setVisits(Array.isArray(data?.items) ? data.items : []);
      setEnabledState(data?.enabled !== false);
      return data;
    } catch (loadError) {
      setError(loadError);
      return null;
    } finally {
      setLoading(false);
    }
  }, [enabled, limit]);

  useEffect(() => {
    reload();
  }, [reload]);

  useEffect(() => {
    if (!enabled) {
      return undefined;
    }

    const handleVisibility = () => {
      if (document.visibilityState === 'visible') {
        reload();
      }
    };

    const handleFocus = () => {
      reload();
    };

    window.addEventListener('focus', handleFocus);
    document.addEventListener('visibilitychange', handleVisibility);

    return () => {
      window.removeEventListener('focus', handleFocus);
      document.removeEventListener('visibilitychange', handleVisibility);
    };
  }, [enabled, reload]);

  return {
    visits,
    loading,
    error,
    enabled: enabledState,
    reload,
  };
}

export default useProfileVisits;
